export default "__VITE_ASSET__ByCzmjZH__"